import { useContext } from 'react';
import MatrixRoomContext from './context';

const useMatrixRoomContext = () => {
  const context = useContext(MatrixRoomContext);

  return context;
};

export { useMatrixRoomContext };
